import "./OutsourceAutomation.css";

export default function OutsourceAutomation() {
  return (
    <div id="outsource-automation" className="outsourcemainclass">
      <div className="left">
        <h2 className="heading">
          Embrace DevOps Automation Consulting Services
        </h2>
        <p className="subheading">
          Accelerate your development lifecycle with intelligent DevOps process
          automation. BastionEx experts help you implement automated workflows
          that strengthen your DevOps transformation, enabling seamless
          deployments, faster releases, and greater transparency across all
          operations. Our continuous delivery automation optimizes resource
          utilization and ensures timely delivery. With scalable, reliable
          DevOps solutions, we help reduce IT failures, enhance system
          stability, and boost developer productivity—empowering your
          organization to deliver high-quality software with confidence and
          speed.
        </p>
      </div>
      <div className="line"></div>
      <div className="right">
        <div className="count">
          <h2>41%</h2>
          <span>
            Reduction in manual effort via GenAI-led workflow automation
          </span>
        </div>
        <div className="count">
          <h2>21%</h2>
          <span>
            Reduction in operational costs through intelligent process
            automation
          </span>
        </div>
        <div className="count">
          <h2>7h</h2>
          <span>
            Faster insights generation using natural language analytics &
            agentic AI
          </span>
        </div>
        <div className="count countborder">
          <h2>60%</h2>
          <span>
            Faster insights generation using natural language analytics &
            agentic AI
          </span>
        </div>
      </div>
    </div>
  );
}
